import React, { Component, Fragment, useState } from 'react';
// import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import { translate } from 'react-i18next';
import cx from '../../../styles';
import { Icon } from '../../Common/Icon';
import { ProfileThumb } from '../../Common/CardComponents';
import BlockUnblockUser from '../../Common/BlockUnblockUser';

const ViewAllBlockedUsers = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [userId, setUserId] = useState('');
    const onActionClick = (userId) => {
        setIsOpen(true)
        setUserId(userId)
    }
    const toggleModal = () => {
        setIsOpen(false)
    }
    const t = props.t;
    return (
        props.userList &&
        <Modal isOpen={props.isModalOpen}
            onRequestClose={props.toggleModal}
            overlayClassName="block-list-modal">
            <span className={cx("close-modal")} onClick={props.toggleModal}>
                <Icon name="cross-regular-dark-smd" />
            </span>
            <div className={cx("view-block-user-component")}>
                <p className={cx("title")}>{t('blocked_users')} ({props.userList.length})</p>
                <p className={cx("text")}>{t('block_list_text')}</p>
                <div className={cx("wrapper")}>
                    {
                        props.userList && props.userList.length > 0 && props.userList.map((data) => {
                            return (
                                <div className={cx("user-wrap")}>
                                    <div className={cx("user-info")}>
                                        <ProfileThumb img={data.image ? data.image : ""} size="small" altName={'profile icon'} />
                                        <p className={cx("user-name")}>{data.fullname}</p>
                                    </div>
                                    <button className={cx("unblock")} onClick={() => { onActionClick(data.id) }}>{t('unblock')}</button>
                                </div>
                            )
                        })
                    }
                </div>
                <BlockUnblockUser entityType={'profile'} entityId={userId} status={0} userName={'user'} isOpen={isOpen} toggleModal={toggleModal} blockUser={false} type={'blockList'} cardName={'User Profile'} userId={userId}/>
            </div>
        </Modal>
    );
}

class UserBlockList extends Component {

    constructor(props) {
        super(props);
        this.state = { isModalOpen: false };
    }

    openModal = () => {
        this.setState({ isModalOpen: true })
    }

    toggleModal = () => {
        this.setState({ isModalOpen: false })
    }

    render() {
        const { t } = this.props;
        return (
            this.props.userList &&
            <Fragment>
                <div className={cx("user-block-list-component")} onClick={this.openModal}>
                    <p>{t('blocked_users')} ({this.props.userList.length})</p>
                    {
                        this.props.mobileView ?
                            <Icon name="right-arrow-regular" />
                            :
                            <span>{t('view_all')}</span>
                    }
                </div>
                <ViewAllBlockedUsers t={t} isModalOpen={this.state.isModalOpen} toggleModal={this.toggleModal} userList={this.props.userList} />
            </Fragment>

        );
    }
}

export default translate()(UserBlockList);
